import HomePage from '@/pages/home.vue';
import ImprintPage from '@/pages/imprint.vue';
import ProfilePage from '@/pages/profile.vue';
import RouteMapPage from '@/pages/route-map.vue';
import RouteDetailPage from '@/pages/route-detail.vue';
import PoiMapPage from '@/pages/poi-map.vue';
import PoiDetailPage from '@/pages/poi-detail.vue';
import PoiSliderPage from '@/pages/poi-detail-fullscreen-slider.vue';
import PoiDetailArPage from '@/pages/poi-detail-ar.vue';
import SponsorsPage from '@/pages/sponsors.vue';
import VideoPlayerPage from '@/pages/video-player.vue';
import SettingsPage from '@/pages/settings.vue';
import RouteFilterPage from '@/pages/route-filter.vue';
import PoiFilterPage from '@/pages/poi-filter.vue';
import UnityPage from '@/pages/unity.vue';
import ArLauncherPage from '@/pages/arlauncher.vue';

export default [
    {
        path: '/',
        name: 'Home',
        component: HomePage,
        options: {
            pushState: false,
        }
    },
    {
        path: '/sponsors/',
        name: 'Sponsors',
        component: SponsorsPage,
        options: {
            history: false,
            pushState: false
        }
    },
    {
        path: '/imprint/',
        name: 'Imprint',
        component: ImprintPage,
        options: {
            history: false,
            pushState: false
        }
    },
    {
        path: '/settings/',
        name: 'Settings',
        component: SettingsPage,
        options: {
            history: false,
            pushState: false
        }
    },
    {
        path: '/profile/',
        name: 'Profile',
        component: ProfilePage
    },
    {
        path: '/arlauncher/',
        name: 'AR Launcher',
        component: ArLauncherPage
    },
    {
        path: '/routes/',
        name: 'RouteMap',
        keepAlive: true,
        component: RouteMapPage
    },
    {
        path: '/routes/filter/',
        name: 'RouteFilter',
        component: RouteFilterPage
    },
    {
        path: '/routes/:routeId',
        name: 'RouteDetail',
        component: RouteDetailPage
    },
    {
        path: '/routes/:routeId/map',
        name: 'RouteDetailMap',
        component: PoiMapPage
    },
    {
        path: '/pois/',
        name: 'PoiMap',
        keepAlive: true,
        component: PoiMapPage
    },
    {
        path: '/pois/filter/',
        name: 'PoiFilter',
        component: PoiFilterPage
    },
    {
        path: '/pois/:poiId',
        name: 'PoiDetailPage',
        component: PoiDetailPage
    },
    {
        path: '/pois/:poiId/fullscreen-slider/',
        name: 'PoiSlider',
        component: PoiSliderPage
    },
    {
        path: '/pois/:poiId/ar/',
        name: 'PoiDetailAr',
        component: PoiDetailArPage
    },
    {
        path: '/videoplayer/:videoUrlEncoded/',
        name: 'VideoPlayer',
        component: VideoPlayerPage
    },
    {
        path: '/panoplayer/:panoramaUrlEncoded/',
        name: 'Panorama',
        async async(to, from, resolve, reject) {
            const page = await import('@/pages/panorama-player.vue' /* webpackChunkName: "panoplayer" */);
            resolve({ component: page.default });
        }
    },
    {
        path: '/unity/',
        name: 'Debug',
        component: UnityPage
    }
];
